var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "theicons.co/svg/common-15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "The-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0756931,14.7156246 L36.0651895,19.9960217 C36.0629923,21.100589 36.9566399,21.9977989 38.0612072,21.999996 C39.1657745,22.0021932 40.0629844,21.1085457 40.0651816,20.0039783 L40.0850733,10.0039783 C40.0872736,8.89785707 39.1912008,8 38.0850773,8 L28.0651855,8 C26.960616,8 26.0651855,8.8954305 26.0651855,10 C26.0651855,11.1045695 26.960616,12 28.0651855,12 L33.1344635,12 L23.9814453,21.1530182 L11.4142136,8.58578644 C10.633165,7.80473785 9.36683502,7.80473785 8.58578644,8.58578644 C7.80473785,9.36683502 7.80473785,10.633165 8.58578644,11.4142136 L21.1530182,23.9814453 L8.58578644,36.5486771 C7.80473785,37.3297256 7.80473785,38.5960556 8.58578644,39.3771042 C9.36683502,40.1581528 10.633165,40.1581528 11.4142136,39.3771042 L23.9814453,26.8098724 L33.1344635,35.9628906 L28.0651855,35.9628906 C26.960616,35.9628906 26.0651855,36.8583211 26.0651855,37.9628906 C26.0651855,39.0674601 26.960616,39.9628906 28.0651855,39.9628906 L38.0850773,39.9628906 C39.1912008,39.9628906 40.0872736,39.0650336 40.0850733,37.9589123 L40.0651816,27.9589123 C40.0629844,26.854345 39.1657745,25.9606974 38.0612072,25.9628946 C36.9566399,25.9650918 36.0629923,26.8623017 36.0651895,27.966869 L36.0756931,33.247266 L26.8098724,23.9814453 L36.0756931,14.7156246 Z",
    id: "Combined-Shape",
    fill: "#9BA0B1",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.cb2ef764c60d39afb4766e8ba37ed341.svg";
export { ForwardRef as ReactComponent };